import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Helpers from '@rogues/shared/mixins/helpers';
import { digits, separated } from '@nodes/helpers/number';
import { get } from 'lodash/object';
import { YBadge, YImage, YIcon } from '@components/index';
import Props from './props';

@Component({
    components: {
        YIcon,
        YBadge,
        YImage,
    },
})

/**
 * @name ProductCard
 */
export default class ProductCard extends Mixins(HybridMixin, Helpers, Props) {
    digits = digits;
    separated = separated;

    /**
     * This params will emit when you using _click:addToCart_ event
     */
    addToCartParams: {[key: string]: any} = {
        post_id        : get(this.getValue('wares'), '0.post_id'),
        ware_id        : get(this.getValue('wares'), '0.id'),
        count          : 1,
        sale_price     : get(this.getValue('wares'), '0.sale_price'),
        single_price   : get(this.getValue('wares'), '0.original_price'),
        single_discount: get(this.getValue('wares'), '0.discount'),
        ware_title     : `${this.getValue('title')} ـ ${get(this.getValue('wares'), '0.title')}`,
        post_image     : this.getValue('image'),
        post_tagging   : this.getValue('product_tagging_categories'),
    };

    /**
     * Return router-link object
     *
     * @param {string} name
     * @param {object} post
     * @returns {object}
     */
    routeTo(name: string, post: Record<any, any>): object {
        const params: Record<any, any> = {};
        if (post.url_encode) {
            params.url_encode = post.url_encode;
        } else if (post.id) {
            params.id = post.id;
        }

        return {
            name,
            params,
        };
    }

    /**
     * Calculator Percent Discount
     *
     * @returns {number | string}
     */
    get discountPercent(): number | string {
        const val = (
            (
                (this.getValue('ware_original_price') - this.getValue('ware_sale_price'))
                / this.getValue('ware_original_price')
            )
                * 100);
        // eslint-disable-next-line no-nested-ternary
        return val.toFixed(1)?.toString()?.split('.')[1] === '0'
            ? Math.round(val) : Math.round(val) > 1
                ? Math.round(val) : val.toFixed(1);
    }

    /**
     * Check if product has discount
     *
     * @returns {boolean}
     */
    get hasDiscount(): boolean {
        return this.getValue('ware_original_price') !== this.getValue('ware_sale_price');
    }

    /**
     * Check if product is new
     *
     * @returns {boolean}
     */
    get isNewProduct(): boolean {
        const date = new Date().getTime();
        const diff = date - (this.getValue('published_at') * 1000);
        const days = parseInt((diff / (1000 * 3600 * 24)).toString(), 10);
        return days <= 7;
    }

    /**
     * For do noting :)
     */
    doNothing(): void {}
}
